module.exports = {
  "roleManager": {
    "tanentRole": "租户角色",
    "roleManager": "角色管理",
    roleList: "角色列表",
    addRole: "添加角色",
    editRole: "编辑角色",
    roleName: "角色名称",
    screeningSearchHint: "请输入角色名称",
    roleType: "角色类型",
    roleTypeHint: "请选择角色类型",
    fatherRole: "上级角色",
    fatherRoleHint: "请选择上级角色",
    roleDetails: "角色描述",
    roleDetailsHint: "请输入角色描述",
    "deleteRoleHint": "被删除的角色将不可恢复，确定吗",
    "addRoleHint": "请在右侧输入要新增的角色信息，然后点击保存",
    "menuPermissions": "菜单权限",
  },
};



// WEBPACK FOOTER //
// ./src/i18n/roleManager/en.js